/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";
import { useStaticQuery, graphql } from "gatsby";
import { LANGUAGE, useStore } from "../context/store";

const SEO = ({ description, lang, meta, keywords, title }) => {
  const { language } = useStore();
  const isSpanish = language === LANGUAGE.es;
  const { site, openGraphImage } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            descriptionEs
            author
          }
        }
        openGraphImage: file(name: { eq: "open_graph" }) {
          childImageSharp {
            fluid(maxWidth: 1360, quality: 90) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `
  );
  console.log("openGrpahImage", openGraphImage);

  const metaDescription =
    description || isSpanish
      ? site.siteMetadata.descriptionEs
      : site.siteMetadata.description;

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title || site.siteMetadata.title}
      titleTemplate={
        title ? `%s | ${site.siteMetadata.title}` : `${site.siteMetadata.title}`
      }
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: site.siteMetadata.title,
        },
        {
          property: `og:image`,
          content: openGraphImage.childImageSharp.fluid.src,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          property: `og:locale`,
          content: isSpanish ? "es_MX" : "en_US",
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:title`,
          content: site.siteMetadata.title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
      ]
        .concat(
          keywords.length > 0
            ? {
                name: `keywords`,
                content: keywords.join(`, `),
              }
            : []
        )
        .concat(meta)}
    />
  );
};

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  keywords: [],
  description: ``,
};

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  keywords: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string.isRequired,
};

export default SEO;
